import { isNil } from 'lodash-es'
import React, { FunctionComponent } from 'react'
import { Trans } from 'react-i18next'

import {
  tDefaults,
  tFormats,
  useWriskTranslation,
} from '../../../infrastructure/internationalisation'

interface IPTProps {
  amount?: number
}

export const IPT: FunctionComponent<IPTProps> = ({ amount }) => {
  const { t } = useWriskTranslation()
  const key = !isNil(amount) ? tDefaults('ipt.withTaxAmount') : tDefaults('ipt.default')

  return (
    <Trans
      t={t}
      i18nKey={key}
      components={{
        abbr: <abbr />,
      }}
      values={{
        amount: t(tFormats('currency.long'), { amount }),
      }}
    />
  )
}
